import { Component } from '@angular/core';

@Component({
  selector: 'app-home-hero-v2',
  templateUrl: './home-hero-v2.component.html',
  styleUrl: './home-hero-v2.component.scss'
})
export class HomeHeroV2Component {

}
